import WebFont from 'webfontloader';

WebFont.load({
  google: {
    families: ['Plus Jakarta Sans', 'Mulish', 'sans-serif'],
  },
});

export const theme = {
  breakpoints: ['40em', '52em', '64em', '80em'],
  space: [0, 4, 8, 16, 32, 64, 128, 256, 512],
  fontSizes: [12, 14, 16, 18, 20, 24, 36, 48, 80, 96],
  headingSizes: [24, 36, 48, 64, 96],
  fontWeights: [400, 700],
  sizes: {
    divider: [1, 2, 3, 4],
  },
  lineHeights: {
    solid: 1,
    title: 1.25,
    copy: 1.5,
  },
  letterSpacings: {
    normal: 'normal',
    tracked: '0.1em',
    tight: '-0.05em',
    mega: '0.25em',
  },
  fonts: {
    serif: 'EB Garamond, georgia, times, serif',
    sansSerif:
      'Plus Jakarta Sans, Mulish,  BlinkMacSystemFont, "avenir next", avenir, "helvetica neue", helvetica, ubuntu, roboto, noto, "segoe ui", arial, sans-serif',
  },
  colors: {
    primary: '#259D90',
    secondary: '#075E5D',
    background: '#EAF8F8',
    darkGrey: '#414143',
    darkGreyTint: 'rgb(65,65,67, 0.7)',
    darkGreen: '#269561',
    lightGreen: '#6DC89D',
    teal: '#259D90',
    tealDark: '#075E5D',
    tealTint: '#C1EDED',
    negativeDark: '#870000',
    negativeLight: '#F2E6E6',
    gradient: 'linear-gradient(90deg, rgba(0,136,161,1) 0%, rgba(85,217,157,1) 100%)',
    white: '#FFFFFF',
    grey: '#AAB2B2',
    lightGrey: '#EFEFEF',
    amber: '#F0B729',
    silver: '#F1F1F1',
  },
};

export default theme;
